let cachedSessionId: string | null = null

const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const getSessionId = (): string => {
  if (cachedSessionId) {
    return cachedSessionId
  }

  let sessionId = sessionStorage.getItem('analytics_session_id')

  if (!sessionId) {
    sessionId = generateUUID()
    sessionStorage.setItem('analytics_session_id', sessionId)
  }

  cachedSessionId = sessionId
  return sessionId
}
